import OidcClientProvider from "@/app/providers/oidc-client-provider";
import type { ReactNode } from "react";

/**
 * Top-level providers that must sit above the router.
 *
 * Providers that only need to cover the routed tree live closer to where they
 * are used: `query-provider` at the root route, `app-config-provider` (runtime
 * config + theme) at the `_app` layout route.
 */
export function AppProvider({ children }: { children: ReactNode }) {
  return <OidcClientProvider>{children}</OidcClientProvider>;
}
